



































exports.default = {
  data: ->
    loading: true

  methods:
    name: ->
      'Shared/Loader'

    switch: (loading) ->
      @loading = loading

  created: ->
    EventsBus.$on('switch-loader', @switch)

  beforeDestroy: ->
    EventsBus.$off('switch-loader', @switch)
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/global_loader.vue